import { combineReducers } from "redux";
import { persistStore, persistReducer } from "redux-persist";
import { routerReducer } from "react-router-redux";
import storage from "redux-persist/lib/storage";

import { StoreConst } from "../actions/StoreAction";
import configureStore from "./configureStore";
import rootSaga from "../sagas/";

const persistConfig = {
	key: "root",
	storage: storage,
	version: 1,
};
export const ReducerKeys = {
	AUTHEN:"authen",
	USER:"user",
	ORGANIZATION:"organization",
	SETTING:"setting",
}; 
const createStore = () => {
	const appReducer = combineReducers({
		router: routerReducer,
		[ReducerKeys.AUTHEN]: require("./AuthenReducer").reducer,
		[ReducerKeys.USER]: require("./UserReducer").reducer,
		[ReducerKeys.ORGANIZATION]: require("./OrganizationReducer").reducer,
		[ReducerKeys.SETTING]: require("./SettingReducer").reducer
	});
	const initRootReducer = {
		[ReducerKeys.AUTHEN]: require("./AuthenReducer").initRootReducer,
		[ReducerKeys.USER]: require("./UserReducer").INITIAL_STATE,
		[ReducerKeys.ORGANIZATION]: require("./OrganizationReducer").initRootReducer,
		[ReducerKeys.SETTING]: require("./SettingReducer").INITIAL_STATE
	};
	const rootReducer = (state, action) => {
		if (action.type === StoreConst.CLEAR_STORE) {
			state = initRootReducer;
		}
		return appReducer(state, action);
	};
	return rootReducer;
};

const persistedReducer = persistReducer(persistConfig, createStore());
const store = configureStore(persistedReducer, rootSaga);
const persistor = persistStore(store);

export default store;
export { persistor };


// WEBPACK FOOTER //
// ./src/reducers/index.js